<div class="bodygraph-chart-shell">
  @if (loading()) {
    <p class="chart-status">Bodygraph laden…</p>
  }

  @if (loadError(); as errorMessage) {
    <p class="chart-status chart-status-error">{{ errorMessage }}</p>
  }

  <div class="svg-stage">
    <div
      #svgHost
      class="svg-host"
      (mouseleave)="onSvgHostMouseLeave()"
      (mousemove)="onSvgHostMouseMove($event)"
      (mouseover)="onSvgHostMouseOver($event)"
      (pointerdown)="onSvgHostPointerDown($event)"
      (pointermove)="onSvgHostPointerMove($event)"
      (pointerup)="cancelTouchLongPress()"
      (pointercancel)="cancelTouchLongPress()"
    ></div>
    @if (hdKeynoteTooltip(); as tooltip) {
      <div
        class="hd-keynote-tooltip"
        role="tooltip"
        data-test-id="hd-keynote-tooltip"
        [style.left.px]="tooltip.position.x"
        [style.top.px]="tooltip.position.y"
      >
        @for (row of tooltip.rows; track row.id) {
          <div class="hd-keynote-tooltip__row" data-test-id="hd-keynote-tooltip-row">
            <span class="hd-keynote-tooltip__label">{{ row.label }}:</span> {{ row.text }}
          </div>
        }
      </div>
    }
    @if (hdCenterTooltip(); as tooltip) {
      <div
        class="hd-center-hover-tooltip"
        role="tooltip"
        data-test-id="hd-center-hover-tooltip"
        [style.left.px]="tooltip.position.x"
        [style.top.px]="tooltip.position.y"
      >
        <hd-center-mini-card
          [center]="tooltip.center"
          [variant]="tooltip.variant"
          [isOpen]="tooltip.isOpen"
          [activations]="configuration().activations"
          presentation="hover"
        />
      </div>
    }
    @if (monopoleTooltip(); as tooltip) {
      <div
        class="hd-keynote-tooltip hd-monopole-tooltip"
        role="tooltip"
        data-test-id="hd-monopole-tooltip"
        [style.left.px]="tooltip.position.x"
        [style.top.px]="tooltip.position.y"
      >{{ tooltip.text }}</div>
    }
    @if (showCenterCheatSheet()) {
      <hd-center-cheat-sheet-layer
        [renderState]="baseRenderState()"
        [activations]="configuration().activations"
        [geometry]="centerCheatSheetGeometry()"
      />
    }
    <ng-content></ng-content>
  </div>
</div>
